import { gql } from 'graphql-request'

export const M_APPLY_RETENTION_OFFER = gql`
  mutation ApplyRetentionOffer {
    applyRetentionOffer {
      ... on RetentionOfferResult {
        success
        offerDescription
        newPeriodEnd
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
